const LoadClasses = (editor) => {

    const cssComposer = editor.CssComposer;
    const sm = editor.SelectorManager;
    const sel1 = sm.add('pointer');
    const rule = cssComposer.add([sel1], 'hover');
    rule.set('style', {
        cursor: 'pointer'
    });
    
    editor.CssComposer.setRule(`.align-self-center`,{
        'align-self': 'center'
    })

    editor.CssComposer.setRule(`.table-stripped2 tr:nth-child(even)`,{
        'background-color': '#f2f2f2 !important',
    })

    editor.CssComposer.setRule(`.table-stripped2 td:not(:last-child)`,{
        'border-right': "3px solid white"
    })

    editor.CssComposer.setRule(`.table-stripped2 th:not(:last-child)`,{
        'border-right': "3px solid white"
    })

    editor.CssComposer.setRule(`.manage-btn`,{
        'background-color': '#3A85C5 !important',
        'color': 'white !important'
    })

    editor.CssComposer.setRule('.previous-btn',{
        'background-color': 'rgb(219, 223, 225) !important',
        'color': 'white !important'
    })

    editor.CssComposer.setRule('.archive-btn',{
        'background-color': 'white !important',
        'color': '#3A85C5 !important',
        'border-style': 'solid !important',
        'border-color': '#3A85C5 !important'
    })

    editor.CssComposer.setRule('.delete-btn',{
        'color': 'white !important',
        'background-color': '#e83c52 !important'
    })

    editor.CssComposer.setRule('.height-section',{
        'min-height': '73vh'
    })

    editor.CssComposer.setRule(`.horiz-center-item`,{
        'display': 'flex',
        'justify-content': 'center'
    })

    editor.CssComposer.setRule(`.table-line-height`,{
        'line-height': '230%'
    })

    editor.CssComposer.setRule(`.table-border`,{
        'overflow': 'hidden',
        'border-radius': '12px',
        'outline': '2px solid black !important' 
    })

    editor.CssComposer.setRule(`.max-width`,{
        'width': '100% !important'
    })

    editor.CssComposer.setRule(`.space-around-elements`,{
        'display': 'flex',
        'justify-content': 'space-around'
    })

    editor.CssComposer.setRule(`.table.table-bordered`,{
        'border': '1px solid black',
        'border-radius': '14px',
    })

    editor.CssComposer.setRule('.white-color',{
        color: 'white'
    })

    editor.CssComposer.setRule(`.sticky-footer`,{
        position: 'fixed',
        bottom: '0',
        width: '100%'
    })



    editor.CssComposer.setRule(`.grey-label`,{
        'background-color': '#e9ecef !important'
    })

    editor.CssComposer.setRule('.tooltip-component--empty',{
        width: '50px',
        height: '50px'
    })

    editor.CssComposer.setRule('.tooltip-component',{
        position: 'relative',
        'vertical-align': 'top',
        display: 'inline-block'

    })   

    editor.CssComposer.setRule('.tooltip-component2',{
        position: 'relative',
        'vertical-align': 'top',
        display: 'inline-block'
    })   
    
    editor.CssComposer.setRule('.dropdown-menu2',{
        top: '30px !important' ,
    })

    editor.CssComposer.setRule('.form-check .form-check-input',{
        display: 'inline-block',
        'margin-top': '0.25vw'
    })

    editor.CssComposer.setRule('.list-item-content',{
        display: 'flex'
    })

    editor.CssComposer.setRule('.dropdown-container',{
        position: 'relative !important'
    })

    editor.CssComposer.setRule('.dropdown-menu',{
        position: 'absolute !important',
        transform: 'none !important'
    })
    editor.CssComposer.setRule('.flex',{
        'display': 'flex !important'
    })
    editor.CssComposer.setRule('.margin-left',{
        'margin-left': '1vw !important'
    })
    editor.CssComposer.setRule('.form-box',{
        'min-height': '20px !important',
        'width': 'auto'
    })
    editor.CssComposer.setRule('.absoluteLabel',{
        'position': 'absolute !important',
        'width': '120px !important',
        'background-color': 'rgb(12, 77, 130) !important',
        'border-radius': '0.5vw !important',
        'color': '#fff !important',
        'padding': '5px, 0 !important',
        'z-index': '1 !important',
        'top': '100% !important',
        'left': '45% !important'
        
    })
    editor.CssComposer.setRule('.relativeLabel',{
        'position': 'relative !important',
        'display': 'inline-block !important',
        'width': '100% !important',

    })
    editor.CssComposer.setRule('.selected',{
        'border': '3px solid #0c4d82 !important'
    })
    editor.CssComposer.setRule('.annotation-messages',{
        'position': 'relative'
    })
    editor.CssComposer.setRule('.annotation-messages:after',{
        'position': 'absolute',
        'background-color': '#0c4d82',
        'top': '100%',
        'font-size': '1vw',
        'padding': '2px',
        'color': 'white',
        'white-space': 'nowrap',
        'left': '0px',
        'content': '("attr(annotationname)")'
    })

    editor.CssComposer.setRule('.w3-row-padding img',{
        'margin-bottom': '12px',
    })

    editor.CssComposer.setRule('.w3-sidebar',{
        width: '120px',
        'background': '#222',
    })
    editor.CssComposer.setRule('#main',{
        'margin-left': '120px',
    })

    editor.CssComposer.setRule('.padding-style',{
        'padding': '5px !important',
    })

    editor.CssComposer.setRule('body, h1,h2,h3,h4,h5,h6', {
        'font-family': "Montserrat, sans-serif"
    })

    editor.CssComposer.setRule('.feature', {
        'display': 'inline-flex',
        'align-items': 'center',
        'justify-content': 'center',
        'height': '3rem',
        'width': '3rem',
        'font-size': '1.5rem'
    })

    editor.CssComposer.setRule('.rounded-3',{
        'border-radius': '0.3rem !important'
    })

}


export default LoadClasses;